import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // user: null,
    user: JSON.parse(localStorage.getItem('user')) || null, // جلب البيانات من localStorage
    token: null,
    // isAuthenticated: false,
    isAuthenticated: !!localStorage.getItem('userId'),
    
    // invoice page
    order: JSON.parse(localStorage.getItem('order')) || null,  // استرجاع الـ order من localStorage إذا كان موجودًا

    // equipment profile - ملف المعدة
    selectedEquipment: JSON.parse(sessionStorage.getItem('selectedEquipment')) || null,
  },
  mutations: {
    setUser(state, userData) {
      state.user = userData
      state.token = userData.token
      state.isAuthenticated = true
      localStorage.setItem('userId', userData.id) // تخزين userId في localStorage
      localStorage.setItem('user', JSON.stringify(userData)); // تخزين بيانات المستخدم
    },
    clearUser(state) {
      state.user = null
      state.token = null
      state.isAuthenticated = false
      localStorage.removeItem('userId');
      localStorage.removeItem('user');
    },
    setOrder(state, order) {
      state.order = order;
      // تخزين الـ order في localStorage
      localStorage.setItem('order', JSON.stringify(order));
    },
    clearOrder(state) {
      state.order = null;
      localStorage.removeItem('order');  // مسح الـ order من localStorage
    },
    setSelectedEquipment(state, equipment) {
      state.selectedEquipment = equipment;
      if (equipment) {
        sessionStorage.setItem('selectedEquipment', JSON.stringify(equipment));
      } else {
        sessionStorage.removeItem('selectedEquipment');
      }
    },
  },
  actions: {
    login({ commit }, userData) {
      commit('setUser', userData)
    },
    logout({ commit }) {
      commit('clearUser')
    },
    setOrder({ commit }, order) {
      commit('setOrder', order);
    },
    clearOrder({ commit }) {
      commit('clearOrder');
    },
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    getUser: state => state.user,
    getToken: state => state.token,
    getSelectedEquipment: state => state.selectedEquipment,
  }
})
